import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
    selector: '[CurrencyDecimal]',
    standalone: true
})
export class CurrencyDecimalDirective {

  constructor(private hostElement: ElementRef) { }

  @HostListener('change', ['$event']) onChange(e: any) {
    this.formatValue(this.hostElement.nativeElement.value);
  }

  formatValue(value:string){
    this.hostElement.nativeElement.value = this.returnTwoDecimalPlaces(+value,2)
  }

  returnTwoDecimalPlaces(value:number,decimalPlaces:number){
    return Number(Math.round(parseFloat(value + 'e' + decimalPlaces)) + 'e-' + decimalPlaces).toFixed(decimalPlaces)
  }

}
